import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ServiceConfig } from '../service-config/service-config.interface';

@Injectable({
  providedIn: 'root'
})
export class AngularServiceConfigProvider {
  getConfig(): ServiceConfig {
    return {
      javaApiUrl: environment.javaApiUrl,
      exchangeDealsUrl: environment.exchangeDealsUrl,
      authenticationServerUrl: environment.authServer
    };
  }
}
